var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.9999 102.787L57.7449 100.215C57.4849 99.92 51.3299 92.8675 45.0899 82.9775C36.5724 69.4775 32.2549 57.715 32.2549 48.0175C32.2549 33.12 44.7024 21 59.9999 21C75.2974 21 87.7449 33.12 87.7449 48.0175C87.7449 57.7175 83.4274 69.4775 74.9099 82.9775C68.6699 92.8675 62.5149 99.92 62.2549 100.215L59.9999 102.787ZM59.9999 27C48.0099 27 38.2549 36.4275 38.2549 48.0175C38.2549 64.825 54.0249 86.0825 59.9999 93.5325C65.9724 86.0775 81.7474 64.805 81.7474 48.0175C81.7474 36.4275 71.9924 27 60.0024 27H59.9999Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9999 60C54.2099 60 49.4999 55.29 49.4999 49.5C49.4999 43.71 54.2099 39 59.9999 39C65.7899 39 70.4999 43.71 70.4999 49.5C70.4999 55.29 65.7899 60 59.9999 60ZM59.9999 45C57.5199 45 55.4999 47.0175 55.4999 49.5C55.4999 51.9825 57.5199 54 59.9999 54C62.4799 54 64.4999 51.9825 64.4999 49.5C64.4999 47.0175 62.4799 45 59.9999 45Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin);
export default __webpack_public_path__ + "static/media/LocationPin.7c0bf0eb.svg";
export { ForwardRef as ReactComponent };